export const daysOptions = {
  '0': 'Hoje',
  '7': '7 dias',
  '15': '15 dias',
  '30': '30 dias',
  '60': '60 dias',
  '90': '90 dias',
  '1000': 'Personalizado',
};
